// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1aZia","content":"styles_content__3xzTJ","checkbox":"styles_checkbox__3ofQK","checkboxLabel":"styles_checkboxLabel__10NzD"};